<template>
  <main class="memorial-main">
    <section
      v-if="
        obituaryDetail &&
          obituaryDetail.Movies &&
          obituaryDetail.Movies.length > 0
      "
    >
      <div class="letter-title__wrap" style="cursor:pointer">
        <h4>함께한 순간들</h4>
      </div>

      <v-carousel
        :show-arrows="obituaryDetail.Movies.length > 1"
        height="251"
        hide-delimiters
        hide-delimiter-background
      >
        <v-carousel-item v-for="movie in obituaryDetail.Movies" :key="movie.id">
          <iframe
            style="width:100%;max-width:420px;height:251px;"
            muted
            :src="movie.filePath"
          >
          </iframe>
        </v-carousel-item>
      </v-carousel>
    </section>

    <obituary-message :obituaryDetail="obituaryDetail" />
    <obituary-wreath
      :obituaryDetail="obituaryDetail"
      @handleViewWreath="wreathListFlag = !wreathListFlag"
      @goShop="$emit('goShop')"
    />
    <obituary-wreath-list
      v-if="wreathListFlag"
      :obituary-wreath="obituaryDetail.Wreaths"
      @close="wreathListFlag = !wreathListFlag"
    />
    <!-- <section>
      <div
        class="flower-title__wrap"
        @click="showWreathList = !showWreathList"
        style="cursor:pointer"
      >
        <h4>근조화환 추모하신 분</h4>
        <v-icon>mdi-chevron-right</v-icon>
      </div>

      <v-carousel
        v-if="
          obituaryDetail &&
            obituaryDetail.Wreaths &&
            obituaryDetail.Wreaths.length > 0
        "
        :show-arrows="false"
        cycle
        height="66"
        hide-delimiters
        hide-delimiter-background
        class="msg-card"
        @click="showWreathList = !showWreathList"
      >
        <v-carousel-item
          v-for="(wreath, i) in obituaryDetail && obituaryDetail.Wreaths"
          :key="i"
        >
          <v-sheet height="100%">
            <div class="d-flex align-cetner mt-3">
              <img src="@/assets/icons/obituary/flower.svg" alt="" />
              <div>
                <h6 class="line-clamp">{{ wreath.name }}</h6>
                <p class="line-clamp">{{ wreath.content }}</p>
              </div>
            </div>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
      <button
        v-else
        class="msg-card preview"
        style="width: 100%"
        @click="goShop"
      >
        <img src="@/assets/icons/obituary/flower.svg" alt="" />
        <div>
          <h6 class="line-clamp">첫번째 근조화환을 보내보세요</h6>
          
        </div>
      </button>

      <ObituaryWreathList
        v-if="showWreathList"
        :obituary-wreath="obituaryDetail.Wreaths"
        @close="showWreathList = !showWreathList"
      />
    </section> -->
  </main>
</template>

<script>
import ObituaryWreathList from "./Wreath/ObituaryWreathList.vue";
import ObituaryMessage from "./Message/ObituaryMessage.vue";
import ObituaryWreath from "./Wreath/ObituaryWreath.vue";

export default {
  components: { ObituaryMessage, ObituaryWreathList, ObituaryWreath },

  name: "ObituaryMemorialMain",
  props: ["obituaryDetail"],
  data() {
    return {
      wreathListFlag: false
    };
  }
};
</script>

<style></style>
